/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_In_UseInputs */

const en_us2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In use`)
};

const pt_br2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em uso`)
};

const es_419_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En uso`)
};

const pt_pt2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em uso`)
};

const fr_fr2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const de_de2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const it_it2_gyms_in_use = /** @type {(inputs: Gyms_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In uso`)
};

/**
* | output |
* | --- |
* | "In use" |
*
* @param {Gyms_In_UseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_in_use = /** @type {((inputs?: Gyms_In_UseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_In_UseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_in_use(inputs)
	if (locale === "es-419") return es_419_gyms_in_use(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_in_use(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_in_use(inputs)
	if (locale === "de-DE") return de_de2_gyms_in_use(inputs)
	if (locale === "it-IT") return it_it2_gyms_in_use(inputs)
	return en_us2_gyms_in_use(inputs)
});
export { gyms_in_use as "gyms.in_use" }